import React from 'react';
import { NavLink } from 'react-router-dom';

import { MainRoutes, ReportRoutes } from 'helpers/routes';
import useUser from 'hooks/useUser';

import { activeStyle, Menu, MenuItem } from 'components/templates/menus/styles';

const ReportManageMenu = () => {
  const { isBdataAmin } = useUser();

  return (
    <Menu>
      {isBdataAmin && (
        <MenuItem
          as={NavLink}
          to={`${MainRoutes.REPORTS}/${ReportRoutes.MANAGE}`}
          style={({ isActive }) => (isActive ? activeStyle : undefined)}
        >
          Report Management
        </MenuItem>
      )}
      <MenuItem as={NavLink} to={`${MainRoutes.REPORTS}/${ReportRoutes.VIEW}`}>
        View Reports
      </MenuItem>
    </Menu>
  );
};

export default ReportManageMenu;
